import React, { useState, useEffect } from "react";
import classes from "./InvestmentChart.module.css";
import { Heading, Text } from "components/common";

const InvestmentChart = ({ positions }) => {
  const [summaryData, setSummaryData] = useState({
    totalCapital: 0,
    totalProfitsWithdrawn: 0,
    totalRewardPerCycle: 0,
    activePositions: 0,
    totalExtraProfits: 0
  });

  useEffect(() => {
    if (positions && positions.length > 0) {
      const totals = positions.reduce(
        (acc, position) => {
          acc.totalCapital += Number(position.capital || 0);
          acc.totalProfitsWithdrawn += Number(position.total_profits_withdrawn || 0);
          acc.totalRewardPerCycle += Number(position.reward_per_cycle || 0);
          acc.totalExtraProfits += Number(position.extra_profits || 0);
          if (position.status === "Active") {
            acc.activePositions += 1;
          }
          return acc;
        },
        {
          totalCapital: 0,
          totalProfitsWithdrawn: 0,
          totalRewardPerCycle: 0,
          activePositions: 0,
          totalExtraProfits: 0
        }
      );

      setSummaryData(totals);
    }
  }, [positions]);

  const formatCurrency = (value) => {
    return value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  return (
    <section className={classes.wrapper}>
      <div className={classes.header}>
        <Heading lg semiBold>
          Investment Overview
        </Heading>
      </div>

      <div className={classes.summaryGrid}>
        <div className={classes.summaryCard}>
          <Text sm semiBold primitive600>Total Investment</Text>
          <Heading lg semiBold>
            ${formatCurrency(summaryData.totalCapital)}
          </Heading>
          <Text xs primitive600>Across all positions</Text>
        </div>

        <div className={classes.summaryCard}>
          <Text sm semiBold primitive600>Active Investments</Text>
          <Heading lg semiBold>
            {summaryData.activePositions}
          </Heading>
          <Text xs primitive600>Currently running</Text>
        </div>

        <div className={classes.summaryCard}>
          <Text sm semiBold primitive600>Total Profits Withdrawn</Text>
          <Heading lg semiBold className={classes.profit}>
            ${formatCurrency(summaryData.totalProfitsWithdrawn)}
          </Heading>
          <Text xs primitive600>From all positions</Text>
        </div>

        <div className={classes.summaryCard}>
          <Text sm semiBold primitive600>Expected Rewards</Text>
          <Heading lg semiBold className={classes.profit}>
            ${formatCurrency(summaryData.totalRewardPerCycle)}
          </Heading>
          <Text xs primitive600>Per cycle</Text>
        </div>

        {summaryData.totalExtraProfits > 0 && (
          <div className={classes.summaryCard}>
            <Text sm semiBold primitive600>Extra Profits</Text>
            <Heading lg semiBold className={classes.profit}>
              ${formatCurrency(summaryData.totalExtraProfits)}
            </Heading>
            <Text xs primitive600>Additional earnings</Text>
          </div>
        )}
      </div>
    </section>
  );
};

export default InvestmentChart;

